import React, { useEffect, useState } from "react";
import "../Style/open.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import TopBarAds from "./TopBarAds";

function OpenNews() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ topic: "", details: "" });
  let url = "https://nland.onrender.com/open/" + encodeURIComponent(id);
  useEffect(() => {
    setLoading(true);
    console.log("id", url);
    axios
      .get(url)
      .then((res) => {
        console.log(res);
        setLoading(true);
        setData({ details: res.data[0][0].title, topic: res.data[1][0].topic });
        console.log(data, res.data[1][0].title);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [id]);
  return (
    <div className="opennews">
      <div className="opennews_head">{data?.topic}</div>
      <div className="opennews_bc">
        Nairaland Forum / Nairaland / General / {data?.topic}
      </div>
      <TopBarAds />
      <div className="opennews_top">{data?.topic.split("-")[0]}</div>
      <div className="opennews_mid">
        {loading ? (
          <h2>Loading....</h2>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data?.details }} />
        )}
      </div>
    </div>
  );
}

export default OpenNews;
